import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  root: {
    cursor: 'pointer'
  },

  content: {
    display: 'flex',
    alignItems: 'center',
    gap: '0.5rem'
  },

  title: {
    color: '#7F8487'
  },

  center: {
    display: 'flex',
    alignItems: 'center',
    color: '#7F8487',

    '& > .MuiIconButton-root:hover': {
      backgroundColor: 'transparent'
    },

    '& > svg': {
      marginRight: '0.25rem'
    }
  },

  alert: {
    marginRight: '8px',
    borderRadius: '50%',
    boxSizing: 'border-box',
    width: '10px',
    height: '10px'
  },

  dismiss: {
    position: 'relative',

    '&:hover': {
      '& svg.close': {
        display: 'block'
      }
    },

    '& svg.close': {
      cursor: 'pointer',
      position: 'absolute',
      zIndex: 10,
      bottom: '22px',
      left: '15px',
      color: 'white',
      borderRadius: '70px',
      display: 'none'
    }
  },

  avatar: {
    margin: '0 10px 5px 0',
    width: theme.size.xl,
    height: theme.size.xl,
    fontSize: theme.size.sm,

    '& svg': {
      width: theme.size.xl,
      height: theme.size.xl
    }
  },

  endButtons: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    gap: '0.5rem',
    marginTop: '1rem'
  },

  yesButton: {
    color: theme.palette.primary.main,
    borderColor: theme.palette.primary.main
  }
}))

export default useStyles
